import { INTEGRATION_CONTACTS, extractIntegrationConfigurations } from './integrationConfigurationUtils';
import { GoogleConfig, GoogleLogin } from './integrationTypes';

export const INTEGRATION_LOGIN_GOOGLE: GoogleLogin = {
  CODE: { name: 'code', defaultValue: '' },
};

export const INTEGRATION_CONFIG_GOOGLE_REFRESH_TOKEN = 'refreshToken';
export const INTEGRATION_CONFIG_GOOGLE_ACCESS_TOKEN = 'accessToken';

export const INTEGRATION_CONFIG_GOOGLE: GoogleConfig = {
  CONTACTS: { name: INTEGRATION_CONTACTS, defaultValue: 'true' },
};

export const INTEGRATION_SCOPE_GOOGLE = ['https://www.googleapis.com/auth/contacts'];

export const googleDefaultConfigurations = {
  ...extractIntegrationConfigurations(INTEGRATION_LOGIN_GOOGLE),
  ...extractIntegrationConfigurations(INTEGRATION_CONFIG_GOOGLE),
  [INTEGRATION_CONFIG_GOOGLE_REFRESH_TOKEN]: '',
  [INTEGRATION_CONFIG_GOOGLE_ACCESS_TOKEN]: '',
};
